import React from 'react';
import { Thumbnail } from '@icecreamsocial/components';
import squareLogo from '../../../assets/logo_square.svg';

const SquareLogo = ({ ...props }) => <Thumbnail src={squareLogo} {...props} />;

SquareLogo.displayName = 'SquareLogo';

export default SquareLogo;
